import React from "react";

import ReactDOM from "react-dom";

import "./Modal.scss";

const Modal = ({ isShowing, hide , props }) => {



const refreshTheApp = () => {
  window.location.reload(); 
}

  return isShowing
    ? ReactDOM.createPortal(
        <React.Fragment>
          <div className="modal-overlay" />
          <div className="modal-wrapper">
            <div className="modal">
              <div className="modal-inside">
                <h2>Your form has been sent!!!</h2>
                <h3>Thank you for your interest.</h3>
                <p>
                  If you have any further questions, please don't hesitate to
                  contact us.
                </p>
                <div className="modal-btn">
                  {/* <button  onClick={hide}>
                    BACK
                  </button> */}
                  <button  onClick={() => {
                    refreshTheApp();    
                  }}>
                    START AGAIN
                  </button>
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>,
        document.body
      )
    : null;
};

export default Modal;
